export default "__VITE_ASSET__DxiOi1U1__"